import { combineReducers } from "redux";
import * as actions from "../../actions/types";
import { createSelector } from "reselect";

const data = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_INIT:
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH:
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH_ERROR:
            return null;
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH_SUCCESS:
            return action.data;
        default:
            return state;
    }
};

const isLoading = (state = false, action) => {
    switch (action.type) {
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH:
            return true;
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH_SUCCESS:
        case actions.CHECKOUT_OTHER_SHOWTIMES_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

export const getCheckoutOtherShowtimes = createSelector([state => state.checkoutData.otherShowtimes.data], data => data);

export default combineReducers({
    data,
    isLoading,
});